import React, { useMemo } from 'react'
import CurrencyContext from './CurrencyContext'

export interface CurrencyProviderProps {
  symbol: string
  children: React.ReactNode
}

export default function CurrencyProvider({ symbol, children }: CurrencyProviderProps) {
  const value = useMemo(() => ({ symbol: symbol || '$' }), [symbol])
  return <CurrencyContext.Provider value={value}>{children}</CurrencyContext.Provider>
}
